"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageSchema = exports.ImageMimeTypeSchema = void 0;
const zod_1 = require("zod");
const DrawingBase_1 = require("./DrawingBase");
const XYPosition_1 = require("./XYPosition");
exports.ImageMimeTypeSchema = zod_1.z.enum(['image/png', 'image/jpeg', 'image/bmp', 'application/octet-stream']);
exports.ImageSchema = DrawingBase_1.DrawingBaseSchema.extend({
    type: zod_1.z.literal('image'),
    pos: XYPosition_1.XYPositionSchema,
    width: zod_1.z.number(),
    height: zod_1.z.number(),
    angle: zod_1.z.number().optional(),
    imageRef: zod_1.z.string(),
});
//# sourceMappingURL=Image.js.map